import React, { useState, forwardRef, useRef, useImperativeHandle} from "react";
import Button from 'react-bootstrap/Button';
import Form from "react-bootstrap/Form";
import uploadService from "../services/UploadService";
import {ApplicationRoles} from "./api-authorization/ApiAuthorizationConstants";
import { toast } from "react-toastify";

export const Uploader = forwardRef((props, ref) => {
    const inputRef = useRef(null);

    const {onUploadComplete, fixtureId, userRole, setShowConfirmUpload, hasVideo, closeModal} = props;

    const [uploadFileName, setUploadFileName] = useState(null);

    const [isUploading, setIsUploading] = useState(false);
    const [uploadPercent, setUploadPercent] = useState(0);

    const [uploadError, setUploadError] = useState(null);

    useImperativeHandle(ref, () => ({
        startUpload: () => handleUpload(),
    }))
    let handleDisplayFileDetails = () => {
        if (inputRef.current?.files && inputRef.current.files[0]) {
            setUploadFileName(inputRef.current.files[0].name);
        } else {
            setUploadFileName(null);
        }
    }

    let getVideoFileDetails = (file) => {
        let data = {
            filename: file.name,
            mimetype: file.type
        }
        return data
    }

    let handleUpload = async () => {
        try {
            if (inputRef.current?.files && inputRef.current.files[0]) {
                setIsUploading(true);

                let file = inputRef.current.files[0];

                let videoFileDetails = getVideoFileDetails(file);

                const signedUrlResult = await uploadService.getSignedUrl(videoFileDetails)

                const signedUrl = signedUrlResult.url;
                const videoId = signedUrlResult.videoId;

                let uploadFileResult = await uploadFile(signedUrl, file);
                if (uploadFileResult.successful) {
                    await uploadService.markVideoForProcessing(videoId);
                    await uploadService.saveVideoUrl(fixtureId, videoId);
                }
            }

            if (onUploadComplete) {
                onUploadComplete();
            }
            await closeModal();
            toast.success("Video uploaded successfully");
        } catch (error) {
            console.log(error);
            toast.error("Error uploading video");
        } finally {
            setIsUploading(false);
            setUploadPercent(0);
            setUploadFileName(null);
            setShowConfirmUpload(false);
        }
    }

    let uploadFile = (signedUrl, file) => {
        return new Promise((resolve) => {
            console.log(file);

            const req = new XMLHttpRequest();
            req.upload.onprogress = (event) => {
                setUploadPercent(Math.round((event.loaded / event.total) * 100));
            }
            req.open('PUT', signedUrl)
            req.setRequestHeader('Content-Type', 'video/mp4')
            req.upload.onabort = () => {
                setUploadError("Video Upload Failed");
                //this.resetForm()
            }
            req.upload.onloadend = (event) => {

                let uploaded = true;

                if (event.loaded / event.total == 1) {

                } else {
                    setUploadError("Video Upload Failed");
                    uploaded = false;
                    //this.resetForm()
                }
                return resolve({successful: uploaded});
            }
            req.send(file);
        });
    }

    return <>
        {userRole !== ApplicationRoles.Watcher &&

            <div>
                <div>
                    <h4>Upload video</h4>
                </div>

                {uploadError &&
                    <span>Error</span>
                }

                <hr/>

                <div>
                    <Form>
                        <Form.Label htmlFor="videoUrlInput">Upload Video File</Form.Label>
                        <Form.File
                            ref={inputRef}
                            accept="video/mp4"
                            onChange={handleDisplayFileDetails}
                            label={uploadFileName != null ? uploadFileName : 'Click to upload video'}
                            custom
                        />

                        <Button
                            type="button"
                            variant="primary"
                            className="mt-2"
                            disabled={!uploadFileName || isUploading}
                            onClick={() => {
                                if (hasVideo) {
                                    setShowConfirmUpload(true)
                                } else {
                                    handleUpload()
                                }
                            }}>Upload </Button>

                        {
                            isUploading &&
                            <div>
                                <div className="spinner-border spinner-border-sm mr-1" role="status">
                                </div>
                                <span>Uploading... {uploadPercent}%</span>
                            </div>
                        }
                    </Form>
                </div>
            </div>
        }
    </>;
});

export default Uploader;